import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { RICH_TEXT_ANIMATION_CONFIG, RICH_TEXT_SCREENS } from '../RichText.constants';
import { useEffect } from 'react';
import { getRichTextNavigations } from '../RichText.navigations';
import { RichTextProps } from '../RichText';

/**
 * Add richText left panel navigation animation configs
 */
export const useAddRichTextNavigations = (props: RichTextProps) => {
  const { screens, addNavigations } = useNavigationPaneContext();
  const richTextNavigations = getRichTextNavigations({ ...props });
  useEffect(() => {
    if (!screens.includes(RICH_TEXT_SCREENS[0])) {
      addNavigations(RICH_TEXT_SCREENS, RICH_TEXT_ANIMATION_CONFIG, richTextNavigations);
    }
  }, [addNavigations, screens, richTextNavigations]);
};
